// Custom events bridge — exposes theme cart/product/quickview events to 3rd-party scripts.
// Enabled via window.flu.states.useCustomEvents (snippets/theme-globals.liquid).
//
// Console logs gated behind window.flu?.states?.debugCustomEvents (perf fix 2026-05-27).
// Previously these logged unconditionally on every visit, polluting Clarity error data
// and adding main-thread cost on slow iPhones.
var __ce_debug = typeof window !== "undefined" && window.flu && window.flu.states && window.flu.states.debugCustomEvents === true;
function __ce_log() { if (__ce_debug) { try { console.log.apply(console, arguments); } catch (e) {} } }

document.addEventListener("cart:item-added", function (evt) {
  __ce_log("Item added to the cart", evt.detail.product);
});

document.addEventListener("cart:updated", function (evt) {
  __ce_log("Cart updated", evt.detail.cart);
});

document.addEventListener("cart:error", function (evt) {
  __ce_log("Cart error", evt.detail.errorMessage);
});

document.addEventListener("quick-cart:open", function (evt) {
  __ce_log("Quick cart opened", evt.detail.cart);
});

document.addEventListener("quick-cart:close", function () {
  __ce_log("Quick cart closed");
});

document.addEventListener("quick-cart:rendered", function (evt) {
  __ce_log("Quick cart DOM rendered at:", evt.detail.timestamp, evt.detail.container);
});

document.addEventListener("product:variant-change", function (evt) {
  __ce_log("Product variant changed", evt.detail.variant);
});

document.addEventListener("product:quantity-update", function (evt) {
  __ce_log("Product quantity updated", evt.detail.quantity, evt.detail.variant);
});

document.addEventListener("quickview:loaded", function () {
  __ce_log("Quickview loaded");
});

// ========== SMART ACCORDION DESCRIPTION ==========
// Uses theme's built-in accordion system - no custom JavaScript needed!
// The "Read more" is handled by accordion open/close automatically
// The "Read less" button uses inline onclick to trigger accordion close
